import React from 'react';
import { useCartStore } from '@/ui/store/cart';
import { useCurrencyFormatter } from '@/ui/hooks/useCurrencyFormatter';
import { useTranslations } from 'next-intl';
import { twJoin } from 'tailwind-merge';

function CartSummary({ isOnCartPage = false }: { isOnCartPage?: boolean }) {
  const t = useTranslations('CartSummary');

  const { getTotalAfterDiscount } = useCartStore();

  const { formatCurrency } = useCurrencyFormatter();

  return (
    <div className={twJoin('px-4 py-4 sm:px-6', isOnCartPage ? '' : 'border-t border-neutral-10')}>
      <div
        className={twJoin(
          'flex justify-between text-lg font-bold',
          isOnCartPage && 'sm:text-xl md:text-2xl',
        )}
      >
        <p>{t('Estimated Total')}</p>
        <p>{formatCurrency(getTotalAfterDiscount())}</p>
      </div>
      <p className={twJoin('mt-2', isOnCartPage && 'text-center')}>
        {t('Taxes, Discounts and shipping calculated at checkout')}
      </p>
    </div>
  );
}

export default CartSummary;
